import { render, staticRenderFns } from "./TouchHeader.vue?vue&type=template&id=19848694&scoped=true&"
import script from "./TouchHeader.vue?vue&type=script&lang=js&"
export * from "./TouchHeader.vue?vue&type=script&lang=js&"
import style0 from "./TouchHeader.vue?vue&type=style&index=0&id=19848694&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19848694",
  null
  
)

export default component.exports